import { useTranslation } from "react-i18next";

import { KioskButtonComponentProps } from "@models/components/kiosk.model";

const KioskButtonComponent = ({
  hideSuccessModal,
}: KioskButtonComponentProps) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex gap-2 mt-3 w-100">
      {/* <button
        className="btn btn-primary btn-lg flex-grow-1"
        onClick={() => hideSuccessModal(false)}
      >
        {t("kiosk.bookingAgain")}
      </button> */}
      <button
        className="btn btn-outline-secondary btn-lg flex-grow-1"
        onClick={() => hideSuccessModal(true, true)}
      >
        {t("kiosk.finishBooking")}
      </button>
    </div>
  );
};

export default KioskButtonComponent;
